export default "__VITE_ASSET__BnqoxkRt__"